<template>
  <!-- Left column -->
  <div v-if="isDataLoaded">
    <div class="full-width">
      <p class="card-title">
        {{ getString('module.dashboard.stats.outstandingCarts') }}
      </p>
      <div class="card-block scroll">
        <div class="full-width">
          <line-chart
            v-show="dataReady"
            :chartData="data"
            :options="options"
            :height="220"
            :ref="component"
          />
          <div class="row" v-for="(legend, index) in data.legends" :key="index">
            <!-- Legends -->
            <div
              class="row legend q-ml-md q-mt-md q-mb-sm"
              :class="{
                'text-hidden': data.datasets[index].hidden,
              }"
              @click="toggleData(index)"
            >
              <div :class="legend.color"></div>
              <span>{{ legend.label }}</span>
            </div>
            <div
              class="col q-mr-md q-mt-sm"
              style="display: flex; justify-content: right"
            >
              <div class="legend-text">
                {{ getString('module.dashboard.stats.total') }}:
                <b
                  >{{ index !== 2 ? '&euro;' : '' }}
                  {{ data.totalAmounts[index] }}</b
                >
                {{ index === 2 ? 'Diamonds' : '' }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import statistics from './statisticsComponent';

export default {
  mixins: [statistics],
  data() {
    return {
      component: 'cartItem',
      data: {
        labels: [],
        datasets: [
          this.initDataset(this.getColor('blue')),
          this.initDataset(this.getColor('purple')),
          this.initDataset(this.getColor('red')),
        ],
        totalAmounts: [],
        legends: [
          {
            color: 'blue',
            label: this.getString('module.dashboard.stats.orders'),
          },
          {
            color: 'purple',
            label: this.getString('module.dashboard.stats.quotations'),
          },
          {
            color: 'red',
            label: this.getString('module.dashboard.stats.giftPromotions'),
          },
        ],
      },
      options: {
        scales: this.scaleOptions,
        elements: {
          point: {
            radius: 2,
          },
          line: {
            borderColor: this.getColor('blue'),
          },
        },
        legend: {
          display: false,
        },
      },
    };
  },
  methods: {
    handleData() {
      const stats = this.statisticData;
      this.data.datasets[0].data = stats.period.map(x => x.orderTotal);
      this.data.datasets[1].data = stats.period.map(x => x.quotationTotal);
      this.data.datasets[2].data = stats.period.map(x => x.promotionTotal);
      this.data.totalAmounts[0] = stats.total.orderTotalPrices || 0;
      this.data.totalAmounts[1] = stats.total.quotationTotalPrices || 0;
      this.data.totalAmounts[2] = stats.total.promotionTotalDiamonds || 0;
      this.data.labels = stats.period.map(x => this.formatDate(x.date, this.labelDateFormat));
      this.dataReady = true;
    },
  },
};
</script>

<style lang="stylus" scoped src="@/styles/components/statistics.styl"></style>
